import { SttAlerta } from '@stt-componentes/core-v3';
import { useSignals } from '@preact/signals-react/runtime';

/* @useSignals */
import { alertaMensagem, fecharAlerta } from '../signals/alerta';

function Alerta() {
    useSignals();
    const alerta = alertaMensagem.value;

    const handleOnClose = () => {
        const onClose = alerta.onClose;
        fecharAlerta();
        onClose?.();
    };

    const options =
        Array.isArray(alerta.options) && alerta.options.length > 0
            ? alerta.options
            : [
                  {
                      title: 'Ok',
                      onClick: handleOnClose,
                  },
              ];

    return (
        <SttAlerta
            open={Boolean(alerta.open)}
            title={alerta.title}
            message={alerta.message}
            type={alerta.type}
            options={options}
            onClose={handleOnClose}
        />
    );
}

export default Alerta;
